<!-- eslint-disable -->
<template lang="pug">
    div(v-if="canShowConversations")
        | {{ $i18n.t('common.common_textInfo_pageNotAllowed') }}
    list-box(v-else)
        div(slot="header" )
            | {{ $i18n.t('conversations.conversations_conversationsHeader_messages') }}
        div.messages-box(slot="preview")
                .messages__menu
                    router-link.menu__item(
                        :to="{name: 'conversations'}"
                        :class="{'menu__item--current': current === 'all'}"
                    )
                        | {{ $i18n.t('conversations.conversations_conversationsMenu_all') }}
                    router-link.menu__item(
                        :to="{name: 'conversations', params: {unread: true}}"
                    )
                        | {{ $i18n.t('conversations.conversations_conversationsMenu_unread') }} ({{ amountOfUnread }})
                    router-link.menu__item(
                        :to="{name: 'messages', params: { favorite: true }}"
                    )
                        | {{ $i18n.t('conversations.conversations_conversationsMenu_marked') }}
                        | ({{ amountOfFavorites }})
                    router-link.menu__item(
                        :to="{name: 'conversations', params: {status: true}}"
                    )
                        | {{ $i18n.t('conversations.conversations_conversationsMenu_archive') }}
                .messages__body
                    .messages-box__status-selector
                        cs-multiselect(
                            :multiple="false"
                            :options="['all', 'unread', 'marked', 'archive']"
                            @input="handleStatusSelect"
                            :value="current"
                            :custom-label="statusName"
                            :placeholder="statusName(current)"
                            :hide-selected="true"
                        )
                    .messages-box__conversation-info
                        router-link.messages-box__receiver(
                            v-if='receiver',
                            :to="{\
                                name: 'user:profile',\
                                params: {id: receiver.id, type: receiver.type}\
                            }"
                        )
                            img.avatar(:src='receiver.avatar')
                            | {{ receiver.firstName }} {{ receiver.lastName }}
                        .messages-box__conversation(v-else-if='conversation')
                            img.avatar(:src='conversation.avatar')
                            .conversation__info
                                span(v-html="conversation.name.split(',').join(',<br>')")
                                a.conversation__button(
                                    v-if='conversation && conversation.users.length > 2'
                                    href='javascript://',
                                    @click='showUsers = true'
                                )
                                    | {{ $i18n.t('conversations.conversations_conversation_viewUsers') }}
                        .messages-box__search-box
                            cs-input.messages-box__search-input(
                                type="text"
                                :placeholder="$i18n.t('conversations.conversations_conversations_searchPlaceholder')"
                                v-model="form.body"
                                @keyup.native.enter="sendForm"
                            )
                            a(href='javascript://', @click="sendForm")
                                svg-icon.messages-box__search-icon(name="search" size="large")
                    hr.messages__divider
                    template(v-if="!isLoading" )
                        .messages
                            div(ref='messages')
                                v-infinite-scroll.messages__container(
                                    @top="loadMessages('top')",
                                    @bottom="loadMessages('bottom')"
                                    :style="{'max-height': isAvailableToSendMessage ? 400 + 'px': 700 + 'px'}"
                                )
                                    .has-text-centered(v-if='messages.length === 0')
                                        | {{ $i18n.t('conversations.conversations_conversation_noMessages') }}
                                    .messages-loader(v-if='currentTopPage !== lastPage')
                                        cs-loader
                                    template(v-for='(messages, date) in groupMessagesByDate')
                                        .messages__date {{ getDay(date) }}
                                        .letter(
                                            v-for='message in messages',
                                            :key='message.id', :ref='message.id',
                                            @scroll='loadMessages(message.id)'
                                        )
                                            .letter__header--small
                                                router-link(
                                                    :to="{\
                                                        name: 'user:profile',\
                                                        params: {id: message.sender.id, type: message.sender.type}\
                                                    }"
                                                )
                                                    img.avatar(:src='message.sender.avatar')
                                                div
                                                    .letter__name {{ message.sender.fullName }}
                                                    .letter__time {{ getTime(message.createdAt) }}
                                                    a.letter__button(
                                                        href='javascript://',
                                                        @click='changeFavoriteStatusOfMessage(message, !message.isFavorite)'
                                                    )
                                                        svg-icon.letter__icon(
                                                            :name="!message.isFavorite ? 'star' : 'star-checked'",
                                                            size="large"
                                                            :class="{'letter__icon--checked': message.isFavorite}"
                                                        )
                                                        span
                                                            | {{ favoriteStatusString(message.isFavorite) }}
                                            router-link.letter__img(
                                                :to="{\
                                                    name: 'user:profile',\
                                                    params: {id: message.sender.id, type: message.sender.type}\
                                                }"
                                            )
                                                img.avatar(:src='message.sender.avatar')
                                            .letter__content
                                                .letter__header
                                                    div
                                                        .letter__name {{ message.sender.fullName }}
                                                        .letter__time {{ getTime(message.createdAt) }}
                                                    a.letter__button(
                                                        href='javascript://',
                                                        @click='changeFavoriteStatusOfMessage(message, !message.isFavorite)'
                                                    )
                                                        svg-icon.letter__icon(
                                                            :name="!message.isFavorite ? 'star' : 'star-checked'",
                                                            size="large"
                                                            :class="{'letter__icon--checked': message.isFavorite}"
                                                        )
                                                        span
                                                            | {{ favoriteStatusString(message.isFavorite) }}
                                                .letter__body
                                                    .letter__text
                                                        span(v-html='filteredMessage(message.body)', v-if='message.body')
                                                    .letter__attachments(v-if='message.attachments.length > 0')
                                                        a.message__attachment(
                                                            v-for='attachment in message.attachments'
                                                            :href='attachment.url',
                                                            target='_blank'
                                                        )
                                                            svg-icon.letter__file-icon(name="paper", width="22px", height="22px")
                                                            | {{ attachment.originalName }}
                                        hr.messages__divider
                                    .messages-loader(v-if='currentBottomPage !== 1')
                                        cs-loader
                            .message__form(v-if='isAvailableToSendMessage')
                                textarea.textarea(
                                    :placeholder="$i18n.t('conversations.conversations_conversation_messagePlaceholder')",
                                    @keydown.enter='keyDownHandler',
                                    v-model='message',
                                    v-autosize='message',
                                    :class="{'textarea--disabled': isMessageLoading}",
                                    ref='textarea',
                                    v-focus=''
                                )
                                .message__buttons
                                    label.label-button(for='file-select')
                                        svg-icon.label-button__icon(name="paperclip", height="19px", width="19px")
                                        span
                                            | {{ $i18n.t('conversations.conversations_conversation_attachFiles') }}
                                        input#file-select(type='file', ref='fileSelect', @change='setFiles', multiple)
                                    cs-button(
                                        color="blue"
                                        @click="sendMessageHandler"
                                    )
                                        | {{ $i18n.t('conversations.conversations_conversation_sendMessage') }}
                                .message__attachment-files(v-if='files.length')
                                    .message__attachment(v-for='(file, index) in files')
                                        | {{ file.name }}
                                        a.message__delete-file(href='javascript://', @click='deleteFile(index)')
                                            svg-icon(name="cancel", size="x-large")
                    cs-loader(v-else)

                    conversation-users-modal(
                        v-if="showUsers"
                        :users="this.conversation ? this.conversation.users : []"
                        @close="showUsers = false"
                    )
</template>

<script>
    /*eslint-disable*/
    import MessageApi from '../../../api/communication/message'
    import ConversationApi from '../../../api/communication/conversation'

    import amountsOfMessages from '../../../utils/communication/amountsOfMessages'
    import canShowConversations from '../../../utils/user/canShowConversations'
    import receiveMessage from '../../../utils/communication/receiveMessage'

    import ListBox from '../../lists/ListBox.vue'
    import ConversationUsersModal from '../../../modals/ConversationUsersModal'

    import linkifyStr from 'linkifyjs/string'
    import {mapState} from 'vuex'
    import moment from 'moment'
    import _ from 'lodash'

    export default {
        data () {
            return {
                messages: [],
                conversation: null,
                isLoading: false,
                receiver: null,
                form: {
                    body: '',
                    conversationId: null,
                    amountOfElements: 30
                },
                message: '',
                showUsers: false,
                files: [],
                isMessageLoading: false,
                isActive: false,
                current: 'all',
                isAmountsLoading: false,
                currentTopPage: null,
                currentBottomPage: null,
                lastPage: null
            }
        },
        beforeDestroy () {
            this.setDataToSessionStorage()
            window.removeEventListener('beforeunload', this.setDataToSessionStorage)
        },
        props: ['id', 'messageId'],
        mixins: [amountsOfMessages, receiveMessage, canShowConversations],
        mounted () {
            window.addEventListener('beforeunload', this.setDataToSessionStorage, {once: true})
            this.message = window.sessionStorage.getItem(`messageToConversation${this.id}`) || ''
            this.fetchData()
        },
        methods: {
            filteredMessage (message) {
                message = linkifyStr(message, {});
                return message
                    .replace(/&lt;/g, '<')
                    .replace(/&gt;/g, '>');
            },
            setDataToSessionStorage () {
                window.sessionStorage.setItem(`messageToConversation${this.id}`, this.message)
            },
            loadMessages (direction) {
                let form = this.form
                if (direction === 'top') {
                    if (this.currentTopPage < this.lastPage) {
                        this.currentTopPage++
                        form.page = this.currentTopPage
                    } else {
                        return
                    }
                } else {
                    if (this.currentBottomPage > 1) {
                        this.currentBottomPage--
                        form.page = this.currentBottomPage
                    } else {
                        return
                    }
                }
                MessageApi.list(form)
                .then((data) => {
                    this.messages = _.uniqBy(this.messages.concat(data.data), 'id')
                    return data.data[0].id
                })
                .then(id => {
                    if (direction === 'top') {
                        this.$refs[id][0].scrollIntoView()
                    }
                })
            },
            keyDownHandler (event) {
                if (!event.shiftKey) {
                    event.preventDefault()
                    this.sendMessageHandler()
                }
            },
            deleteFile (index) {
                this.files.splice(index, 1)
            },
            setFiles (e) {
                let files = e.target.files || e.dataTransfer.files
                if (!files.length) {
                    return
                }
                for (let file of files) {
                    if (this.files.length < 10) {
                        if (!(this.isInFiles(file))) {
                            this.files.push(file)
                        }
                    }
                }
                e.target.value = ''
            },
            isInFiles (file) {
                for (let localFile of this.files) {
                    if (localFile.name === file.name && file.size === localFile.size) {
                        return true
                    }
                }
                return false
            },
            changeFavoriteStatusOfMessage (message, status) {
                MessageApi.update(message.id, {userId: this.user.id, check: status})
                .then(() => {
                    message.isFavorite = status
                    status ? this.amountOfFavorites++ : this.amountOfFavorites--
                })
            },
            handleStatusSelect (selector) {
                switch (selector) {
                    case 'all':
                        this.$router.push({name: 'conversations'})
                        break
                    case 'unread':
                        this.$router.push({name: 'conversations', params: {unread: true}})
                        break
                    case 'marked':
                        this.$router.push({name: 'messages', params: {favorite: true}})
                        break
                    case 'archive':
                        this.$router.push({name: 'conversations', params: {status: true}})
                        break
                }
            },
            getTime (date) {
                return moment(date).format('LT')
            },
            getDay (date) {
                date = moment(date)
                if (date.year() !== moment().year()) {
                    return date.format('LL')
                } else if (date.diff(moment(new Date()), 'days') >= -1) {
                    return date.calendar() + ', ' + date.format('D MMMM')
                }
                return date.format('D MMMM')
            },
            sendMessageHandler () {
                if (this.receiver && this.receiver.status !== 'archived') {
                    this.sendMessage()
                    return
                } else if (this.receiver) {
                    this.$toasted.error(this.$i18n.t('conversations.conversations_createMessage_receiverIsInArchive'))
                    return
                }
                this.$toasted.error(this.$i18n.t('conversations.conversations_createMessage_receiverIsDeleted'))
            },
            sendMessage () {
                if ((this.message.trim().length > 0 || this.files.length > 0) && !this.isMessageLoading) {
                    this.isMessageLoading = true
                    this.$refs['textarea'].blur()
                    let message = this.message.split('\n').filter(string => string).join('\n')
                    let formData = new FormData()
                    formData.append('body', message)
                    formData.append('conversation_id', this.form.conversationId)
                    formData.append('sender_id', this.user.id)
                    this.files.forEach((element, index) => {
                        formData.append(`files[${index}]`, element)
                    })
                    MessageApi.create(formData)
                    .then(data => {
                        this.message = ''
                        window.sessionStorage.removeItem(`messageToConversation${this.id}`)
                        ConversationApi.update(this.conversation.id, {readAt: true})
                        this.conversation.lastMessage = data
                        this.files = []
                        this.$refs['textarea'].focus()
                        this.isMessageLoading = false
                        return data
                    })
                    .then((message) => {
                        this.$refs[message.id] && this.$refs[message.id][0].scrollIntoView()
                    })
                    .catch(error => {
                        this.isMessageLoading = false
                        if (error.response.status === 403) {
                            this.$toasted.error(error.response.data.message)
                        }
                    })
                }
            },
            sendForm () {
                this.isLoading = true
                this.form.conversationId = this.conversation.id
                if (this.messageId) {
                    this.form.messageId = this.messageId
                } else {
                    this.form.messageId = this.conversation.lastMessage.id
                }
                MessageApi.list(this.form)
                .then(data => {
                    this.messages = data.data.reverse()
                    this.currentTopPage = data.currentPage
                    this.currentBottomPage = data.currentPage
                    if (!data.data.length) {
                        this.lastPage = 1
                    } else {
                        this.lastPage = data.lastPage
                    }
                    delete this.form.messageId
                    this.isLoading = false
                })
                .then(() => {
                    this.scrollToMessage()
                })
            },
            scrollToMessage () {
                if (this.messageId) {
                    if (this.$refs[this.messageId]) {
                        this.$refs[this.messageId][0].scrollIntoView()
                    }
                } else if (this.form.body === '') {
                    if (this.$refs[this.conversation.lastMessage.id]) {
                        this.$refs[this.conversation.lastMessage.id][0].scrollIntoView()
                    }
                }
            },
            fetchData () {
                this.isLoading = true
                ConversationApi.show(this.id)
                .then((conversation) => {
                    this.conversation = conversation
                    this.form.conversationId = this.conversation.id
                    if (this.conversation.users.length === 2) {
                        this.conversation.users.forEach(user => {
                            this.user.id !== user.id && (this.receiver = user)
                        })
                    }
                    if (conversation.lastMessage.unread) {
                        this.amountOfUnread--
                    }
                    ConversationApi.update(this.conversation.id, {readAt: true})
                    this.sendForm()
                })
                .catch(err => {
                    if (err && err.response && err.response.data.status_code === 403) {
                        this.$toasted.error(err.response.data.message)
                        this.$router.push({name: 'conversations'})
                    }
                    this.isLoading = false
                })
            },
            statusName (status) {
                return this.$i18n.t(`conversations.conversations_conversationsMenu_${status}`)
            },
            favoriteStatusString (isFavorite) {
                return isFavorite
                        ? this.$i18n.t('conversations.conversations_conversation_removeMark')
                        : this.$i18n.t('conversations.conversations_conversation_mark')
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            isAvailableToSendMessage() {
                return this.conversation && this.conversation.users.length === 2 && this.receiver.type !== 'support';
            },
            groupMessagesByDate () {
                this.messages = _.orderBy(this.messages, ['createdAt']).filter(message => message)
                return _.groupBy(this.messages, message => moment(message.createdAt).format('YYYY-MM-DD'))
            }
        },
        components: {
            ListBox,
            ConversationUsersModal
        }
    }
</script>

<style lang="scss" scoped>
    .messages-box {
        display: flex;
    }

    .messages__menu {
        display: none;
        @include media($xlg) {
            display: flex;
            flex-direction: column;

            font-size: 18px;
            line-height: 42px;

            min-width: 180px;
            margin-right: 30px;
        }
    }

    .menu__item, .messages-box__receiver, .conversation__button {
        color: $hsl-color-blue-56;
        text-decoration: underline;

        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .menu__item--current {
        color: $x-color-black;
        text-decoration: none;

        &:hover {
            color: $x-color-black;
            text-decoration: none;
        }
    }

    .messages__body {
        padding: 0;
        width: 100%;
    }

    .messages-box__status-selector {
        display: flex;
        @include media($xlg) {
            display: none;
        }
    }

    .messages-box__conversation-info {
        display: flex;
        flex-direction: column;
        margin: 10px 0;
        @include media($md) {
            flex-direction: row;
            justify-content: space-between;
        }
        @include media($xlg) {
            margin: 30px 0;
        }
    }

    .messages-box__receiver {
        display: flex;
        align-items: center;
        margin-right: 20px;
        @include media($xlg) {
            white-space: nowrap;
        }
    }

    .messages-box__conversation {
        display: flex;
        align-items: center;
        margin-right: 20px;
        @include media($xlg) {
            white-space: nowrap;
        }
    }

    .conversation__info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 80px;
    }

    .conversation__button {
        margin-top: 10px;
    }

    .messages-box__search-box {
        margin: 15px 0;
        display: flex;
        align-items: center;
        @include media($xl) {
            min-width: 330px;
        }
    }

    .messages-box__search-box .cs-input {
        margin: 0;
    }

    .messages-box__search-icon {
        color: $hsl-color-blue-56;
        margin-left: 10px;
    }

    .messages-box__fields {
        display: flex;
        padding: 0;
        margin: 30px 0;
    }

    .messages-box__message-statuses {
        display: flex;
        flex-direction: column;
        @include media($xlg) {
            flex-direction: row;
        }
    }

    .messages-box__message-status-checkbox {
        margin: 0 20px 0 0;
    }

    .messages-box__message-status {
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: underline;

        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }

        &:last-child {
            margin: 0;
        }

        @include media($xlg) {
            margin: 0 60px 0 0;
        }
    }

    .messages-box__status-icon {
        margin-right: 10px;
    }

    .message {
        display: flex;
        align-items: center;
    }

    .messages__info {
        margin-top: 30px;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
    }

    .avatar {
        border-radius: 50%;
        margin-right: 30px;
        max-height: none;
        height: 80px;
        width: 80px;
        border: none;
    }


    .messages__container {
        max-height: 400px;
        overflow-x: hidden;
        overflow-y: auto;
        padding-right: 1rem;
        margin-bottom: 10px;
        @include media($md) {
            padding-right: 1.5rem;
        }
    }

    .messages__date {
        margin-top: 30px;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: $x-color-black;
        text-align: center;
    }

    .letter {
        padding: 26px 0;
        min-height: 4.5rem;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
        }
    }

    .letter__header--small {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        @include media($md) {
            display: none;
        }
    }

    .letter__content {
        width: 100%;
    }

    .letter__img {
        display: none;
        margin-bottom: 10px;
        @include media($md) {
            display: block;
        }
    }

    .letter__header {
        display: none;
        margin-bottom: 10px;
        @include media($md) {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
        }
    }

    .letter__name {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
    }

    .letter__time {
        font-size: 14px;
        line-height: 17px;
        color: rgba($hsl-color-gray-20, 0.6);
        margin: 10px 0;
    }

    .letter__body {
        margin-bottom: 30px;
    }

    .letter__text {
        white-space: pre-line;
        word-break: break-word;
    }

    .letter__button {
        display: flex;
        align-items: center;
        color: $x-color-black;
    }

    .letter__icon {
        margin-right: 10px;
        color: $hsl-color-gray-82;

        &:hover {
            color: $x-color-orange;
        }
    }

    .letter__icon--checked {
        color: $x-color-orange;

        &:hover {
            color: $hsl-color-gray-82;
        }
    }

    .messages__divider {
        border: 0;
        background: $hsl-color-gray-74;
        height: 1px;
        width: 100%;
        margin: 0 auto;

        &:last-child {
            display: none;
        }
    }

    .textarea {

        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border-radius: $border-radius-5;
        border: 1px solid $hsl-color-gray-74;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        //@include inset-squish-space($space-small);

        padding: 12px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }

        align-items: center;
        height: 2.25em;
        justify-content: flex-start;
        position: relative;
        vertical-align: top;
        background-color: $x-color-white;
        box-shadow: inset 0 1px 2px hsla(0, 0%, 4%, .1);
        max-width: 100%;

        display: block;
        min-width: 100%;

        word-wrap: break-word;
        resize: none;
        max-height: 200px;
        min-height: 100px;

        overflow: hidden;
        overflow-wrap: break-word;
    }

    .textarea--disabled {
        cursor: not-allowed;
        pointer-events: none;
        background-color: $x-color-white;
        color: $hsl-color-gray-74;
    }

    .message__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 30px;
        @include media($md) {
            justify-content: space-between;
            flex-direction: row;
        }
    }

    .message__attachment-files {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        margin-top: 20px;
    }

    .message__attachments {
        padding-top: 5px;
        white-space: pre-line;
        word-break: break-word;
    }

    .message__attachment {
        display: flex;
        align-items: center;
        margin-right: 20px;
        color: $hsl-color-blue-56;
        text-decoration: underline;
        font-size: 16px;
        line-height: 24px;
        margin-top: 10px;
    }

    .message__delete-file {
        color: $hsl-color-gray-74;

        &:hover {
            color: $hsl-color-red-62;
        }
    }

    .label-button {
        box-sizing: border-box;

        padding: 15px 30px;

        transition: 0.3s;

        font-weight: normal;
        font-size: 16px;
        line-height: 19px;

        border-radius: $border-radius-40;

        cursor: pointer;
        outline: none;

        display: flex;
        vertical-align: middle;
        text-align: center;
        justify-content: center;
        align-items: center;

        color: $hsl-color-blue-56;
        background-color: transparent;
        border: 1px solid $hsl-color-blue-56;


        margin-bottom: 10px;
        @include media($md) {
            margin-bottom: 0;
        }
    }

    .label-button:hover {
        color: $x-color-white;
        background-color: $hsl-color-blue-48;
    }

    .label-button__icon {
        margin-right: 14px;
    }

    #file-select {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
    }

    ::-webkit-scrollbar {
        width: 3px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    ::-webkit-scrollbar {
        background-color: #F5F5F5;
        height: 2px;
    }

    ::-webkit-scrollbar-thumb {
        height: 2px;
        background: $color-grey-600;
    }
</style>
